import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import Button from '../UI/Button'
import useMutateData from '../../hooks/useMutateData'
import { useContext, useEffect } from 'react'
import { authContext } from '../../context/auth-context'
import viewFileApi from '../../services/viewFileApi'
import ViewFileForm from '../ViewFileForm'

const EditViewFile = () => {
  useEffect(() => {
    document.title = 'Edit View File - Analog Group'
  }, [])

  const navigate = useNavigate()
  const { viewFiles } = useOutletContext()
  const params = useParams()
  const { token } = useContext(authContext)

  const { mutate: editViewFile, isLoading } = useMutateData({
    key: 'view-files',
    mutationFn: viewFileApi.editViewFile,
    successMessage: 'View file has been updated successfully',
  })

  const viewFile = viewFiles?.find(task => task?.id === +params?.id)

  const onSubmit = async values => {
    editViewFile(
      { values, token },
      {
        onSuccess: () => {
          navigate(-1)
        },
      }
    )
  }

  return (
    <div>
      <div>
        <h4 id='formTitle'>Edit View File</h4>
        <Button onClickHandler={() => navigate(-1)} text='< Back' />
      </div>
      <ViewFileForm onSubmit={onSubmit} isLoading={isLoading} viewFile={viewFile} />
    </div>
  )
}

export default EditViewFile
